import { useMsal } from "@azure/msal-react";
import {
  ROLE_CONTADURIA,
  ROLE_COMPRADOR,
  ROLE_CONTROL_PAGOS,
  ROLE_APROBADOR_PAGOS,
  type AppRole,
} from "../constants/roles";

/**
 * Lee el claim `roles` del ID token de la cuenta activa. Easy Auth en el
 * backend valida el token igual — esto es solo para decidir qué mostrar en
 * la UI (nunca la única barrera real de seguridad, el backend re-valida
 * todo con `_requiere_rol()`).
 */
export function useRoles(): AppRole[] {
  const { accounts } = useMsal();
  const account = accounts[0];
  const claims = account?.idTokenClaims as { roles?: string[] } | undefined;
  return filtrarRolesConocidos(claims?.roles ?? []);
}

/**
 * Lista blanca de roles (pura, para poder testearla): un rol desconocido en
 * el token no habilita nada. Sumar un rol nuevo exige agregarlo acá, o se
 * descarta en silencio.
 */
export function filtrarRolesConocidos(roles: string[]): AppRole[] {
  return roles.filter(
    (r): r is AppRole =>
      r === ROLE_CONTADURIA ||
      r === ROLE_COMPRADOR ||
      r === ROLE_CONTROL_PAGOS ||
      r === ROLE_APROBADOR_PAGOS
  );
}

export function useHasRole(role: AppRole): boolean {
  return useRoles().includes(role);
}
